module.exports = __webpack_public_path__ + "img/newsImg2.781eb7ad.png";